<template>
    <div class="container-fluid job-container">
        <form
            action=""
            @submit.prevent="saveJob"
        >
            <div class="row">
                <div class="col-12 col-md-6">
                    <div
                        class="card job-details-card"
                        v-if="!loading && job"
                    >
                        <div class="card-body">
                            <div class="form-group">
                                <label for="name">Job Name:</label>
                                <input
                                    name="name"
                                    v-model="job.name"
                                    id="name"
                                    class="form-control"
                                    required
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.name"
                                >{{ errors.name[0] }}</small>
                            </div>

                            <div class="form-group">
                                <div class="form-group">
                                    <label for="colour">Job Colour:</label>
                                    <input
                                        name="colour"
                                        type="color"
                                        v-model="job.color"
                                        id="colour"
                                        class="form-control"
                                        required
                                    >
                                    <small
                                        class="form-error"
                                        v-if="errors.colour"
                                    >{{ errors.colour[0] }}</small>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="form-group">
                                    <label
                                        for="is_call_out"
                                        class="label"
                                    >Job Type:</label>
                                    <p>
                                        <input
                                            name="is_call_out"
                                            type="checkbox"
                                            v-model="job.is_call_out"
                                            id="is_call_out"
                                        >
                                        Is call out?
                                    </p>
                                    
                                    <small
                                        class="form-error"
                                        v-if="errors.is_call_out"
                                    >{{ errors.is_call_out[0] }}</small>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="site">Job Status:</label>
                                <select
                                    name="status"
                                    v-model="job.status"
                                    id="status"
                                    class="form-control"
                                    placeholder="Status"
                                    required
                                >
                                    <option
                                        v-for="status in statuses"
                                        :key="status.value"
                                        :value="status.value"
                                    >
                                        {{ status.name }}
                                    </option>
                                </select>
                                <small
                                    class="form-error"
                                    v-if="errors.status"
                                >{{ errors.status[0] }}</small>
                            </div>

                            <div class="form-group">
                                <label for="first_name">First name:</label>
                                <input
                                    name="first_name"
                                    v-model="job.first_name"
                                    id="first_name"
                                    class="form-control"
                                    :required="firstNameRequired"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.first_name"
                                >{{ errors.first_name[0] }}</small>
                            </div>

                            <div class="form-group">
                                <label for="last_name">Last name:</label>
                                <input
                                    name="last_name"
                                    v-model="job.last_name"
                                    id="last_name"
                                    class="form-control"
                                    :required="lastNameRequired"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.last_name"
                                >{{ errors.last_name[0] }}</small>
                            </div>

                            <div class="form-group">
                                <label for="important_info">Important Info:</label>
                                <textarea
                                    name="important_info"
                                    v-model="job.important_info"
                                    id="important_info"
                                    class="form-control"
                                    rows="4"
                                />
                                <small
                                    class="form-error"
                                    v-if="errors.important_info"
                                >{{ errors.important_info[0] }}</small>
                            </div>

                            <div class="form-group">
                                <label for="description">Job Description:</label>
                                <textarea
                                    name="description"
                                    v-model="job.description"
                                    id="description"
                                    class="form-control"
                                    rows="4"
                                    placeholder="Date/times stated? Who have you spoke to? Cost agreed? Quote number? Any further information..."
                                    required
                                />
                                <small
                                    class="form-error"
                                    v-if="errors.description"
                                >{{ errors.description[0] }}</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div
                        class="card job-customer-card"
                        v-if="!loading && job.customer"
                    >
                        <div class="card-body">
                            <div class="form-group">
                                <label for="customer">Customer:</label>
                                <customer-search
                                    ref="customerSearch"
                                    :customer="job.customer"
                                    @change="customerChanged"
                                />
                                <small
                                    class="form-error"
                                    v-if="errors.customer_id"
                                >{{ errors.customer_id[0] }}</small>
                                <div
                                    class="form-group"
                                    v-if="job.customer.sites"
                                >
                                    <label for="site">Site:</label>
                                    <select
                                        name="site"
                                        v-model="job.site_id"
                                        id="site"
                                        class="form-control"
                                        placeholder="Site"
                                        required
                                        v-if="job.customer.sites.length"
                                        @change="siteChanged"
                                    >
                                        <option
                                            v-for="site in job.customer.sites"
                                            :key="site.id"
                                            :value="site.id"
                                        >
                                            #{{ site.site_no }} {{ site.name }}
                                        </option>
                                    </select>
                                    <span
                                        class="form-error"
                                        v-if="!job.customer.sites.length"
                                    >This customer has no sites</span>
                                    <small
                                        class="form-error"
                                        v-if="errors.site_id"
                                    >{{ errors.site_id[0] }}</small>
                                </div>
                            </div>
                            <div
                                class="form-group"
                                v-if="job.site"
                            >
                                <div
                                    class="job-map"
                                    id="job-map"
                                />
                                <h6>{{ job.site.name }}</h6>
                                <ul class="address-list">
                                    <li
                                        v-for="(line, index) of address"
                                        :key="index"
                                    >
                                        {{ line }}
                                    </li>
                                </ul>
                                <a
                                    v-if="directionsUrl"
                                    :href="directionsUrl"
                                    class="btn btn-outline-secondary"
                                    target="_blank"
                                >
                                    <i class="fa fa-location-arrow" /> View Map
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div
                        class="card job-times-card"
                        v-if="!loading && job.time_slots"
                    >
                        <div class="card-body">
                            <h5>Times</h5>
                            <table class="table table-light-head">
                                <thead>
                                    <th>Start:</th>
                                    <th />
                                    <th>End:</th>
                                    <th>Engineer:</th>
                                    <th v-if="job.time_slots && job.time_slots.length > 1" />
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(slot, index) in job.time_slots"
                                        :key="index"
                                    >
                                        <td>
                                            <date-picker
                                                v-model="slot.start"
                                                required
                                                :options="{format: 'L'}"
                                            />
                                            <small
                                                class="form-error"
                                                v-if="errors['time_slots.'+index+'.start']"
                                            >{{ errors['time_slots.'+index+'.start'][0] }}
                                            </small>
                                        </td>
                                        <td>-</td>
                                        <td>
                                            <date-picker
                                                v-model="slot.end"
                                                :options="{format: 'L'}"
                                                required
                                            />
                                            <small
                                                class="form-error"
                                                v-if="errors['time_slots.'+index+'.end']"
                                            >{{ errors['time_slots.'+index+'.end'][0] }}
                                            </small>
                                        </td>
                                        <td>
                                            <div class="form-group">
                                                <select
                                                    name="user"
                                                    v-model="slot.user_id"
                                                    id="user"
                                                    class="form-control"
                                                    placeholder="Engineer"
                                                    @change="timeSlotUserChanged(index)"
                                                    required
                                                >
                                                    <option
                                                        v-for="u in engineers"
                                                        :key="u.id"
                                                        :value="u.id"
                                                        :disabled="!u.engineer_access"
                                                    >
                                                        {{ u.name }}
                                                    </option>
                                                </select>
                                                <small
                                                    class="form-error"
                                                    v-if="errors['time_slots.'+index+'.user_id']"
                                                >
                                                    {{ errors['time_slots.'+index+'.user_id'][0] }}
                                                </small>
                                            </div>
                                        </td>
                                        <td v-if="job.time_slots.length > 1">
                                            <button
                                                @click.prevent="removeATime(index)"
                                                class="btn btn-sm btn-outline-danger"
                                            >
                                                <i class="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="5">
                                            <button
                                                class="btn btn-sm btn-outline-primary"
                                                @click.prevent="addATime()"
                                            >
                                                <i class="fa fa-plus" /> Add a time
                                            </button>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                            <p v-if="!job.time_slots">
                                No times assigned
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="form-group">
                                <label>Forms:</label>
                                <table
                                    class="table table-light-head"
                                    v-if="job.id"
                                >
                                    <thead>
                                        <tr>
                                            <th>Doc No.</th>
                                            <th>Type</th>
                                            <th>Last Updated</th>
                                            <th><!-- options --></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(form, i) in job.forms"
                                            :key="i"
                                        >
                                            <td>{{ form.doc_no || '-' }}</td>
                                            <td>{{ form.type }}</td>
                                            <td>{{ form.updated_at || '-' }}</td>
                                            <td>
                                                <router-link
                                                    :to="{name: 'office.forms.new', query: {type: form.type, job_id: job.id}}"
                                                    class="btn btn-sm btn-info"
                                                    v-if="!form.id"
                                                >
                                                    <i class="fa fa-pencil-alt" />
                                                </router-link>
                                                <router-link
                                                    :to="{name: 'office.forms.edit', params: {id: form.id}}"
                                                    class="btn btn-sm btn-info"
                                                    v-if="form.id"
                                                >
                                                    <i class="fa fa-pencil-alt" />
                                                </router-link>
                                                <router-link
                                                    :to="{name: 'office.forms.edit', params: {id: form.id}}"
                                                    class="btn btn-sm btn-info"
                                                    v-if="form.id"
                                                >
                                                    <i
                                                        class="fa fa-print"
                                                    />
                                                </router-link>
                                                <button
                                                    class="btn btn-sm btn-outline-danger"
                                                    @click.prevent="deleteForm(i)"
                                                    type="button"
                                                >
                                                    <i class="fa fa-times" />
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td>
                                                <select
                                                    name="form_type"
                                                    id="form_type"
                                                    v-model="newFormType"
                                                    class="form-control"
                                                >
                                                    <option
                                                        v-for="type in formTypes"
                                                        :key="type.value"
                                                        :value="type.value"
                                                    >
                                                        {{ type.name }}
                                                    </option>
                                                </select>
                                            </td>
                                            <td colspan="5">
                                                <button
                                                    class="btn btn-sm btn-outline-primary"
                                                    @click.prevent="addAForm()"
                                                    type="button"
                                                >
                                                    <i class="fa fa-plus" /> Add a form
                                                </button>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                                <p
                                    class="error"
                                    v-if="!job.id"
                                >
                                    Save the job to add forms
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Attachments</h3>
                            <attachments
                                v-if="job.id"
                                type="App\Job"
                                :id="job.id"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="form-group col-12 col-md-3">
                            <label for="invoiced_at">Invoiced On:</label>
                            <date-picker
                                v-model="job.invoiced_at"
                                id="invoiced_at"
                                :options="{format: 'L'}"
                            />
                            <small
                                class="form-error"
                                v-if="errors['invoiced_at']"
                            >
                                {{ errors['invoiced_at'][0] }}
                            </small>
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="invoiced_by_id">Invoiced By:</label>
                            <select
                                name="invoiced_by_id"
                                v-model="job.invoiced_by_id"
                                id="invoiced_by_id"
                                class="form-control"
                                placeholder="Staff"
                            >
                                <option
                                    :value="null"
                                    disabled
                                >
                                    Select user
                                </option>
                                <option
                                    v-for="u in officeStaff"
                                    :key="u.id"
                                    :value="u.id"
                                >
                                    {{ u.name }}
                                </option>
                            </select>
                            <small
                                class="form-error"
                                v-if="errors['invoiced_by_id']"
                            >
                                {{ errors['invoiced_by_id'][0] }}
                            </small>
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="po_number">Purchase Order No.</label>
                            <input
                                v-model="job.po_number"
                                id="po_number"
                                type="text"
                                class="form-control"
                            >
                            <small
                                class="form-error"
                                v-if="errors['po_number']"
                            >
                                {{ errors['po_number'][0] }}
                            </small>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <button
                        type="submit"
                        class="btn btn-primary"
                    >
                        <i class="fa fa-save" /> Save Job
                    </button>
                    <activity-log
                        v-if="job.id"
                        :id="job.id"
                        model="Job"
                    />
                    <router-link
                        :to="{ name: 'office.jobs.list' }"
                        class="btn btn-outline-secondary"
                    >
                        <i class="fa fa-search" /> Search Jobs
                    </router-link>
                    <router-link
                        :to="{ name: 'office.jobs.show', params: { id: job.id } }"
                        class="btn btn-info"
                    >
                        <i class="fa fa-pencil-alt" /> View Job
                    </router-link>
                </div>
            </div>

            <span v-if="loading">Loading
                <i class="fa fa-spin fa-spinner" />
            </span>
        </form>
    </div>
</template>

<script>
import JobService from "../../../services/JobService";
import AuthService from "../../../services/AuthService";
import * as Job from "../../../include/Job";
import CustomerSearchComponent from "../../CustomerSearch.vue";
import datePicker from "../../DateTimePickerComponent.vue";
import UsersService from "../../../services/UsersService";
import * as moment from "moment";
import * as Form from "../../../include/Form";
import FormService from "../../../services/FormService";
import Attachments from '../../AttachmentsComponent';

export default {

    components: {
        "customer-search": CustomerSearchComponent,
        "date-picker": datePicker,
        Attachments,
    },
    props: ["id"],
    data: function () {
        return {
            job: {},
            loading: false,
            map: null,
            user: {},
            now: window.moment(),
            timer: null,
            errors: {},
            statuses: Job.statuses,
            engineers: [],
            officeStaff: [],
            formTypes: Form.types,
            newFormType: Form.types[0].value,
            firstNameRequired: false,
            lastNameRequired: false,
        };
    },

    computed: {
        address: function () {
            const address = [];
            const keys = [
                "address_line_1",
                "address_line_2",
                "address_line_3",
                "town",
                "region",
                "postcode",
                "country"
            ];
            if (this.job.site.address) {
                const a = this.job.site.address;
                for (let k of keys) {
                    if (a[k]) {
                        address.push(a[k]);
                    }
                }
            }
            return address;
        },

        directionsUrl: function () {
            if (!this.job.site.address.lat || !this.job.site.address.lng) {
                return null;
            }
            return encodeURI(
                [
                    "https://www.google.com/maps/dir/?api=1",
                    "destination=" +
                        this.job.site.address.lat +
                        "," +
                        this.job.site.address.lng,
                    "travelmode=driving"
                ].join("&")
            );
        }
    },

    mounted: function () {
        AuthService.getUser().then(user => {
            this.user = user;
        });
        this.getEngineers();
        this.getOfficeStaff();
        this.loadJob();
        this.timer = setInterval(() => {
            this.now = moment();
        }, 100);
    },

    unmounted: function () {
        clearInterval(this.timer);
    },

    methods: {
        loadJob: function () {
            this.loading = true;
            JobService.get(this.id).then(
                res => {
                    this.job = res.data;
                    this.firstNameRequired = this.nameWasPresent(res.data.first_name);
                    this.lastNameRequired = this.nameWasPresent(res.data.last_name);
                    this.loading = false;
                    this.initMap();
                    window.metaTitle('Edit Job | ' + this.job.name);
                },
                err => {
                    alert("Error: Failed to load job");
                }
            );
        },

        nameWasPresent: function (value) {
            if (value === null || value === undefined) {
                return false;
            }

            return String(value).trim() !== '';
        },

        saveJob: function () {
            JobService.update(this.job).then(
                xhr => {
                    alert("Job saved successfully");
                },
                err => {
                    if (typeof err.response.data.errors !== 'undefined') {
                        this.errors = err.response.data.errors;
                        alert("Please check the job form for errors");
                    } else {
                        alert("There was a problem saving the job");
                        throw err;
                    }
                }
            );
        },

        initMap: function () {
            const site = {
                lat: this.job.site.address.lat,
                lng: this.job.site.address.lng
            };
            setTimeout(() => {
                this.map = new window.google.maps.Map(document.getElementById("job-map"), {
                    zoom: 16,
                    center: site
                });
                const marker = new window.google.maps.Marker({
                    position: site,
                    map: this.map
                });
            }, 500);
        },

        customerChanged: function (customer) {
            if (customer === null) {
                this.job.customer = {};
                this.job.customer_id = null;
                this.job.site_id = null;
                this.job.site = null;
            } else {
                this.job.customer = customer;
                this.job.customer_id = customer.id;
                if (!this.job.site_id && this.job.customer.sites.length) {
                    this.job.site_id = this.job.customer.sites[0].id;
                    this.job.site = this.job.customer.sites[0];
                    this.siteChanged();
                }
            }
        },

        siteChanged: function() {
            if (this.job.site && this.job.site.address) {
                this.initMap();
            }
        },

        getEngineers: function() {
            return new Promise((fulfill, reject) => {
                UsersService.engineers().then(
                    xhr => {
                        this.engineers = xhr.data;
                        fulfill();
                    },
                    err => {
                        reject(err);
                    }
                );
            });
        },

        getOfficeStaff: function() {
            return new Promise((fulfill, reject) => {
                UsersService.officeStaff().then(
                    xhr => {
                        this.officeStaff = xhr.data;
                        fulfill(xhr);
                    },
                    err => {
                        reject(err);
                    }
                );
            });
        },

        timeSlotUserChanged(index) {
            const timeSlot = this.job.time_slots[index];
            // Set new user based on id
            if (!timeSlot.user || timeSlot.user_id !== timeSlot.user.id) {
                timeSlot.user = this.engineers.find(e => {
                    return e.id === timeSlot.user_id;
                });
                return;
            }
            // Set user based on user object
            if (timeSlot.user) {
                let inEngineers = this.engineers.findIndex(e => {
                    return e.id === timeSlot.user.id;
                });
                if (inEngineers === -1) {
                    this.engineers.push(timeSlot.user);
                }
                this.job.time_slots[index].user_id = timeSlot.user.id;
            } else {
                // Cannot set the object
                this.job.time_slots[index].user_id = null;
            }
        },

        addATime: function(date = null) {
            if (this.job.time_slots.length) {
                const lastSlot = this.job.time_slots[this.job.time_slots.length - 1];
                this.job.time_slots.push({
                    user: lastSlot.user ? lastSlot.user : this.engineers[0],
                    start: moment(lastSlot.start),
                    end: moment(lastSlot.end)
                });
            } else {
                const date = date
                    ? date
                    : moment()
                        .add(1, "hour")
                        .startOf("hour");
                this.job.time_slots.push({
                    start: date,
                    end: moment(date).add(30, "minutes"),
                    user: this.engineers[0],
                    user_id: this.engineers[0].id
                });
            }
            this.timeSlotUserChanged(this.job.time_slots.length - 1);
        },

        removeATime: function(index) {
            this.job.time_slots.splice(index, 1);
        },

        addAForm: function () {
            const form = {
                job_id: this.job.id,
                customer_id: this.job.customer_id,
                site_id: this.job.site_id,
                type: this.newFormType,
                add_form_fields: true,
            };
            FormService.nextNo().then(res => {
                form.doc_no = res.data;
                FormService.create(form).then(res => {
                    this.job.forms.push(res.data);
                }, err => {
                    alert('Error: Could not create new form');
                });
            });

        },

        deleteForm: function (i) {
            const form = this.job.forms[i];
            if (form.id) {
                if (confirm('Are you sure you want to delete this form?')) {
                    FormService.delete(form).then(res => {
                        this.job.forms.splice(i);
                    }, err => {
                        alert('Error: could not delete form');
                    });
                }
            } else {
                this.job.forms.splice(i);
            }
        },
    }
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/office/jobs/EditComponent.vue